export * from './mat-badge-icon.directive';
export * from './mat-badge-icon.module';
